// src/pages/home/index.jsx

import React, { useEffect } from 'react';
import Preloader from '../../components/Preloader';
import Banner from '../../components/Banner';
import CertificationListing from './Certification';

/**
 * Certifications Page Component
 * Renders the certifications page with preloader, banner, and certification listing.
 * 
 * This component applies and cleans up specific body classes required for styling.
 */
const Certifications = () => {

	useEffect(() => {
		const bodyClassList = document.body.classList;
		bodyClassList.add('inner-page', 'certification');

		return () => {
			bodyClassList.remove('inner-page', 'certification');
		};
	}, []);

	return (
		<>
			<Preloader />
			<Banner page={{ title: 'Certifications' }} />
			<CertificationListing />
		</>
	);
};

export default Certifications;
